<template>
  <div ref="panelRsPases" v-resize="configPlano">
    <v-tabs v-model="active" color="white" dark fixed-tabs slider-color="red darken-4" grow>
      <v-tab v-for="(s, indxs) in solapas" :key="indxs" ripple class="black--text">
        {{ s.titulo }}
      </v-tab>
      <v-tab-item v-for="(s, indxc) in solapas" :key="indxc">
        <v-card flat color="transparent">
          <v-card-text>
            <component
              v-bind:is="s.componente"
              :data="s.data"
              :plano="plano"
              :soloTickets="true"
              :mostrarBuscador="false"
            ></component>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
// ListadoTicketsPredeterminados
import ListadoTicketsFlexibles from "@/components/pases/ListadoTicketsFlexibles.vue"
export default {
  name: "contenedorPasesHoteles",
  props: ["data"],
  components: {
    ListadoTicketsFlexibles
  },
  mounted() {},
  created() {
    this.solapas = []
    this.tomarTickets()
    this.muestraBuscadorInterno()
  },
  methods: {
    tomarTickets() {
      this.tomarFechaFlexibles()
      this.tomarFechaPredeterminada()
      this.tomarPromocionales()
    },
    tomarFechaPredeterminada() {
      const calendarios = this.data.pases.find(p => p.tipo === "C")
      if (calendarios == undefined) {
        return
      }
      const toAdd = {
        rs: calendarios.rs,
        comparador: calendarios.comparador,
        regimen: calendarios.regimen
      }
      this.addSolapa("Tickets con fechas predeterminada", "ListadoTicketsFlexibles", toAdd)
    },
    tomarFechaFlexibles() {
      const flexibles = this.data.pases.find(p => p.tipo === "F").rs.filter(r => r.valor != 1000)
      if (flexibles.length === 0) {
        return
      }
      const toAdd = { rs: flexibles, comparador: flexibles.comparador }
      this.addSolapa("Tickets con fechas flexibles", "ListadoTicketsFlexibles", toAdd)
    },
    tomarPromocionales() {
      const promocionales = this.data.pases.find(p => p.tipo === "F").rs.filter(r => r.valor == 1000)
      if (promocionales.length === 0) {
        return
      }
      const toAdd = { rs: promocionales, comparador: promocionales.comparador }
      this.addSolapa("Tickets Promocionales", "ListadoTicketsFlexibles", toAdd)
    },
    addSolapa(titulo, componente, data) {
      this.solapas.push({ titulo: titulo, componente: componente, data: data })
    },
    configPlano() {
      if (this.$refs.panelRsPases == undefined) {
        return
      }
      let width = this.$refs.panelRsPases.clientWidth
      this.plano = "row"
      if (width <= 400 && width != 0) {
        this.plano = "column"
      }
    },
    muestraBuscadorInterno() {
      return !this.data.pases.some(tipoPase => tipoPase.comparador === undefined)
    }
  },
  data() {
    return {
      solapas: [],
      active: null,
      plano: "row"
    }
  }
}
</script>
